import getters from '@/store/hoPaginatedList/getters';

export default getters;
